module.exports = __webpack_public_path__ + "img/close.bdc92267.svg";